const apiUrl = process.env.VITE_API_URL
const authApiUrl = process.env.VITE_AUTH_API_URL
const baseDomain = process.env.VITE_BASE_DOMAIN
const isLocalHost = window.location.hostname === 'localhost'
const devMode = process.env.VITE_ENV_MODE === 'development'
const isProduction = process.env.VITE_ENV_MODE === 'production'
const auth0Domain = process.env.VITE_AUTH0_DOMAIN
const auth0ClientId = process.env.VITE_AUTH0_CLIENT_ID
const auth0RedirectUri = process.env.VITE_AUTH0_REDIRECT_URI
const auth0LogoutRedirectUri = process.env.VITE_AUTH0_LOGOUT_REDIRECT_URI
const auth0Audience = process.env.VITE_AUTH0_AUDIENCE
const firebaseApiKey = process.env.VITE_FIREBASE_API_KEY
const firebaseAuthDomain = process.env.VITE_FIREBASE_AUTH_DOMAIN
const firebaseProjectId = process.env.VITE_FIREBASE_PROJECT_ID
const firebaseStorageBucket = process.env.VITE_FIREBASE_STORAGE_BUCKET
const firebaseMessagingSenderId = process.env.VITE_FIREBASE_MESSAGING_SENDER_ID
const firebaseAppId = process.env.VITE_FIREBASE_APP_ID
const firebaseVapidKey = process.env.VITE_FIREBASE_VAPID_KEY
const posthogApiKey = process.env.VITE_POSTHOG_API_KEY
const posthogApiHost = process.env.VITE_POSTHOG_API_HOST

const FIREBASE_CONFIG = {
  apiKey: firebaseApiKey,
  authDomain: firebaseAuthDomain,
  projectId: firebaseProjectId,
  storageBucket: firebaseStorageBucket,
  messagingSenderId: firebaseMessagingSenderId,
  appId: firebaseAppId,
}

export {
  apiUrl,
  authApiUrl,
  baseDomain,
  isLocalHost,
  devMode,
  isProduction,
  auth0Domain,
  auth0ClientId,
  auth0RedirectUri,
  auth0LogoutRedirectUri,
  auth0Audience,
  FIREBASE_CONFIG,
  firebaseVapidKey,
  posthogApiKey,
  posthogApiHost,
}
